export default __webpack_public_path__ + "static/tobias-9387947a99735e072a5a1d59381dafc1.png";